(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lights-switch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-lights-toggle]');
    if (!toggle) return;

    var host = toggle.closest('.lights');
    if (!host) return;

    var off = host.classList.toggle('is-off');
    toggle.setAttribute('aria-checked', off ? 'true' : 'false');
  });
  } catch(e) { console.error(e); }
})();

})();
